import { FormattedMessage } from 'react-intl';

const DriverMultiSelectChangeStatusValue = {
    ACTIVATE: 'activate',
    ARCHIVE: 'archive',
} as const;

type DriverMultiSelectChangeStatusValue =
    (typeof DriverMultiSelectChangeStatusValue)[keyof typeof DriverMultiSelectChangeStatusValue];

export { DriverMultiSelectChangeStatusValue };

interface DriverMultiSelectChangeStatusDialogBodyOwnProps {
    selectedDriversCount: number;
    newStatus: DriverMultiSelectChangeStatusValue;
}

export const DriverMultiSelectChangeStatusDialogBody = (props: DriverMultiSelectChangeStatusDialogBodyOwnProps) => {
    return (
        <div data-testid={`driver-multi-select-${props.newStatus}-dialog-body`}>
            <FormattedMessage
                id={`intl-msg.multiSelect.${props.newStatus}.content`}
                values={{ amount: props.selectedDriversCount }}
            />
        </div>
    );
};
